import { getTags } from "./assets/js/api";

/**
 * 获取tagList
 * @param goodsList 数据源
 * @param channel 频道
 * @param functionType 购物车只查爆炸贴为2的营销信息
 * @param returnLimit Boolean 
 * @param cb 回调
 * return String
 */
export function fetchTagsList (goodsList, channel, functionType, returnLimit,  cb) {
  let params = {
    channel: channel,
    goodsList: goodsList
  }
  if (functionType) {
    params.functionType = functionType
  }
  if (returnLimit) {
    params.returnLimit = returnLimit
  }
  try {
    goodsList.length > 0 && getTags(params).then((d) => {
      const tagList = d && d.data && d.data.body;
      if (tagList) {
        cb && cb(tagList);
      } else {
        cb && cb(goodsList);
      }
    });
  } catch (error) {
    console.log(error);
    cb && cb(goodsList);
  }
};

/**
 * 处理tagList
 * @param tagList 数据源
 * @param good 需要拼接的商品
 * @param prop1 属性
 * @param noNew 是否保留新品标签 true 不保留
 * @param noLimit 是否保留起购限购标签 true 不保留 （eq:购物车）
 * @param noHealth 健康模块不展示type为1的标签
 * return good
 */
export function dealTagsList (tagList, good, prop1, noNew, noLimit, noHealth) {
  if (tagList) {
    const goodTag = prop1
      ? tagList.find((tag) => tag.categoryId == good[prop1].categoryId && tag.goodsId == good[prop1].goodsId)
      : tagList.find((tag) => tag.categoryId == good.categoryId && tag.goodsId == good.goodsId);
    let tags = goodTag && goodTag.tags ? goodTag.tags : [];
    // type 1、促销 2、爆炸贴 3、新品
    // mktFrontType 9003、限购 9004、起购 9005频道标签 9006运营标签 90061运营标签 90062运营标签 9007体检自营标签 300001抽奖
    // 过滤掉新品
    if (noNew) {
      tags = tags.filter(tag => tag.type != 3)
    }
    // 过滤掉限购、起购
    if (noLimit) {
      tags = tags.filter(tag => !tag.mktFrontType || (tag.mktFrontType != 9003 && tag.mktFrontType != 9004))
    }
    const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
    const salePrice = goodTag && goodTag.salePrice ? goodTag.salePrice : '';
    // console.log('让我看看这是什么', tagList, goodTag, tags, promPrice, salePrice)

    if (prop1) {
      good[prop1].tags = tags;
      good[prop1].promoStickerInfo = [];
      good[prop1].hasPromoSticker = false;

      good[prop1].hasPromoTags = false;
      good[prop1].promoTags = [];

    } else {
      good.tags = tags;
      good.promoStickerInfo = [];
      good.hasPromoSticker = false;

      good.hasPromoTags = false;
      good.promoTags = [];

    }
    

    // 折上折
    if (goodTag) {
      const tagShow = good.discountTagShow || goodTag.discountTagShow
      good.mktTagShow = good.mktTagShow || goodTag.mktTagShow || null;
      good.discountTagShow = (typeof tagShow === 'number' )? tagShow : null;
      good.discountPrice = good.discountPrice || goodTag.discountPrice || null;
      good.discount = good.discountEnText || goodTag.discountEnText || null;
      good.discountEnText = good.discountEnText || goodTag.discountEnText || null;
      good.totalLimit = good.totalLimit || goodTag.totalLimit;
      good.saleNum = good.saleNum || goodTag.saleNum || 0;
      good.dfPriceVo = good.dfPriceVo || goodTag.dfPriceVo || null;
    }

    good.bizStock = goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
    tags && tags.length > 0 && tags.map((info, i) => {
      // type 1、促销 2、爆炸贴 3、新品
      if (info.type === 2) {
        if (prop1){
          good[prop1].promoStickerInfo.push(info);
          good[prop1].hasPromoSticker = true;
        } else {
          good.promoStickerInfo.push(info);
          good.hasPromoSticker = true;
        }
      } else if (info.type === 1) {
        if (!noHealth) {
          if (prop1) {
            good[prop1].hasPromoTags = true;
            good[prop1].promoTags.push(info);
          } else {
            good.hasPromoTags = true;
            good.promoTags.push(info);
          }
        }
      } else {
        if (prop1) {
          good[prop1].hasPromoTags = true;
          good[prop1].promoTags.push(info);
        } else {
          good.hasPromoTags = true;
          good.promoTags.push(info);
        }
      }
    });
    if (prop1) {
      good[prop1].promPrice = promPrice;
      good[prop1].salePrice = salePrice;
    } else {
      good.promPrice = promPrice;
      good.salePrice = salePrice;
    }
    
    // console.log('此时的goods:', good[prop1])
    // debugger
    return good
  } else {
    return good
  }
};



// 异步设置tag到good,直接修改的原数组
export const setTagsToGoodsSync = (goods, item) => {
  return new Promise((resolve, reject) => {
    let ids = []
    goods.forEach((item) => {
      const id = item.id || item.goodsId
      if (item.categoryId && id) {
        ids.push({
          goodsId: id,
          categoryId: item.categoryId,
        })
      } else if ([3, 64, 32].includes(item.channel)) {
        ids.push({
          goodsId: item.id,
          channelId: item.channel,
        })
      }
    })
    if (ids.length == 0) {
      resolve(goods)
      return 
    }

    getTags(ids).then((res) => {
      if (res && res.data && res.data.body) {
        res.data.body.map((item) => {
          let good = {}
          good.promoStickerInfo = []
          good.hasPromoSticker = false
          good.hasPromoTags = false
          good.promoTags = []
          
          const index = goods.findIndex((t) => ( t.id || t.goodsId) == item.goodsId && t.categoryId == item.categoryId)
         
          if (item.tags && item.tags.length > 0) {
            const tags = item && item.tags ? item.tags : []
            tags &&
              tags.length > 0 &&
              tags.map((info, i) => {
                // type 1、促销 2、爆炸贴 3、新品
                // mktFrontType 9003、限购 9004、起购 9005频道标签 9006运营标签 90061导购标签 90062推荐标签 9007 体检自营标签 300001抽奖
                if (info.type === 2) {
                  good.promoStickerInfo.push(info)
                  good.hasPromoSticker = true
                } else if (
                  info.type === 1 ||
                  info.type === 3 ||
                  info.mktFrontType === 400001 ||
                  info.mktFrontType === 9003 ||
                  info.mktFrontType === 9004 ||
                  info.mktFrontType === 9005 ||
                  info.mktFrontType === 9006 ||
                  info.mktFrontType === 90061 ||
                  info.mktFrontType === 90062 ||
                  info.mktFrontType === 9007 ||
                  info.mktFrontType === 300001
                ) {
                  good.hasPromoTags = true
                  good.promoTags.push(info)
                }
              })
            if (index > -1) {
              goods[index].tags = item
              goods[index].promoStickerInfo = good.promoStickerInfo
              goods[index].hasPromoSticker = good.hasPromoSticker
              goods[index].hasPromoTags = good.hasPromoTags
              goods[index].promoTags = good.promoTags

              // 折上折
              goods[index].mktTagShow = item.mktTagShow
              goods[index].discountTagShow = item.discountTagShow
              goods[index].discountPrice = item.discountPrice
              goods[index].discount = item.discountEnText
              goods[index].totalLimit = item.totalLimit
              goods[index].saleNum = item.saleNum || 0

              goods[index].promPrice = item.promPrice || 0
              goods[index].salePrice = item.salePrice || 0
              goods[index].dfPriceVo = item.dfPriceVo || null;

              const _good = goods[index]
              if (_good.sellingPrice === undefined && _good.price !== undefined){
                goods[index].sellingPrice = _good.price
              }
            }
            return
          }
          
          // 没有tags标签
          if (index > -1) {
            goods[index].tags = item && item
            goods[index].bizStock = item.bizStock
            // 折上折
            goods[index].mktTagShow = item.mktTagShow
            goods[index].discountTagShow = item.discountTagShow
            goods[index].discountPrice = item.discountPrice
            goods[index].discount = item.discountEnText
            goods[index].totalLimit = item.totalLimit
            goods[index].saleNum = item.saleNum || 0

            goods[index].promPrice = item.promPrice || 0
            goods[index].salePrice = item.salePrice || 0
            goods[index].dfPriceVo = item.dfPriceVo || null;

            const good = goods[index]
            if (good.sellingPrice === undefined && good.price !== undefined){
              goods[index].sellingPrice =  good.price
            }
          }
        })
      }

      item.originTags = true
      resolve(goods)
    }).catch(err => {
      reject(err)
    })
  })
}

/** 20240322 判断是否使用新价格组件
 *
 * // 1、福拼拼 2、外层传来不使用新价格的判断 3、tags接口中dfPriceVo无数据
 * @param goods
 * @param useNewPrice 外层传来不使用新价格的标志。
 * @return {*|*[]}
 */
export function checkUseOldPrice(goods, useNewPrice) {
  // const useOldPrice = goods && goods.groupItem == 'Y' || !useNewPrice || (!goods.dfPriceVo || !goods?.dfPriceVo.redPrice && !goods?.dfPriceVo.purplePrice)
  const useOldPrice = (goods && goods.groupItem == 'Y') || !useNewPrice
  return useOldPrice
}